/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { call, put, takeLatest, all, takeLeading } from "redux-saga/effects";
import * as userAction from "./actions";

import {
  FetchUsers,
  FetchAUser,
  CreateUser,
  UpdateUser,
  EnableUser,
  DisableUser,
  ChangeUserStatus,
  ResendInvite,
  DeleteUser,
  FetchAUserDetails,
  FetchUserRoles,
} from "./services";

// worker saga: makes the api call when watcher saga sees the action
export function* fetchUserSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchUsers, action.payload);
    const users =
      response && response.data && response.data.data ? response.data.data : {};
    users.list = users.result;
    delete users.result;
    yield put(userAction.FetchUsersSuccess(users));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.FetchUsersFailed(error));
  }
}
export function* fetchAUserSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchAUser, action.payload);
    /* istanbul ignore if */
    if (response && response.data) {
      yield put(userAction.FetchAUserSuccess(response.data.data));
    } else {
      yield put(
        userAction.FetchAUserFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.FetchAUserFailed(error));
  }
}
export function* fetchAUserDetailsSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchAUserDetails, action.payload);
    /* istanbul ignore if */
    if (response && response.data) {
      yield put(userAction.FetchAUserDetailSuccess(response.data));
    } else {
      yield put(
        userAction.FetchAUserDetailsFailed(
          response && response.data && response.data.message,
        ),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.FetchAUserDetailsFailed(error));
  }
}
export function* createUserSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(CreateUser, action.payload);
    /* istanbul ignore if */
    if (response && response.data && response.data.success) {
      yield put(userAction.CreateUserSuccess(response.data));
    } else {
      yield put(userAction.CreateUserFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.CreateUserFailed(error));
  }
}
export function* updateUserSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(UpdateUser, action.payload);
    /* istanbul ignore if */
    if (response && response.data && response.data.success === true) {
      yield put(userAction.UpdateUserSuccess(response.data));
    } else {
      yield put(userAction.UpdateUserFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.UpdateUserFailed(error));
  }
}
export function* enableUserSaga(action) {
  try {
    const response = yield call(EnableUser, action.payload);
    if (response === true) {
      yield put(userAction.EnableUserSuccess("success"));
    } else {
      yield put(
        userAction.EnableUserFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.EnableUserFailed(error));
  }
}
export function* disableUserSaga(action) {
  try {
    const response = yield call(DisableUser, action.payload);
    if (response === true) {
      yield put(userAction.DisableUserSuccess("success"));
    } else {
      yield put(
        userAction.DisableUserFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.DisableUserFailed(error));
  }
}
export function* updateUserStatusSaga(action) {
  try {
    const response = yield call(ChangeUserStatus, action.payload);
    if (response && response.data && response.data.success === true) {
      yield put(userAction.UpdateUserStatusSuccess(response.data));
    } else {
      const message =
        response && response.data && response.data.message
          ? response.data.message
          : "Something went wrong. Please try later";
      yield put(userAction.UpdateUserStatusFailed(message));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.UpdateUserStatusFailed(error));
  }
}
export function* resendInviteSaga(action) {
  try {
    const response = yield call(ResendInvite, action.payload);
    if (response && response.data && response.data.success === true) {
      yield put(userAction.ResendInviteSuccess(response.data));
    } else {
      const message =
        response && response.data
          ? response.data
          : "Something went wrong. Please try later";
      yield put(userAction.ResendInviteFailed(message));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.ResendInviteFailed(error));
  }
}

export function* deleteUserSaga(action) {
  try {
    const response = yield call(DeleteUser, action.payload);
    if (response && response.data && response.data.success === true) {
      yield put(userAction.DeleteUserSuccess(response.data));
    } else {
      const message =
        response && response.data && response.data.message
          ? response.data.message
          : "Something went wrong. Please try later";
      yield put(userAction.DeleteUserFailed(message));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.DeleteUserFailed(error));
  }
}
export function* fetchUserRolesSaga(action) {
  try {
    const response = yield call(FetchUserRoles, action.payload);
    if (response && response.data) {
      yield put(userAction.FetchUserRolesSuccess(response.data.data));
    } else {
      yield put(
        userAction.FetchUserRolesFailed({
          message: "Something went wrong. Please try later",
        }),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(userAction.FetchUserRolesFailed(error));
  }
}
// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* userWatcher() {
  yield all([
    takeLatest(userAction.types.FETCH_USERS, fetchUserSaga),
    takeLatest(userAction.types.FETCH_A_USER, fetchAUserSaga),
    takeLeading(userAction.types.CREATE_USER, createUserSaga),
    takeLeading(userAction.types.UPDATE_USER, updateUserSaga),
    takeLatest(userAction.types.ENABLE_USER, enableUserSaga),
    takeLatest(userAction.types.DISABLE_USER, disableUserSaga),
    takeLeading(userAction.types.UPDATE_USER_STATUS, updateUserStatusSaga),
    takeLeading(userAction.types.RESEND_INVITE, resendInviteSaga),
    takeLeading(userAction.types.DELETE_USER, deleteUserSaga),
    takeLatest(userAction.types.FETCH_A_USER_DETAILS, fetchAUserDetailsSaga),
    takeLatest(userAction.types.FETCH_USER_ROLES, fetchUserRolesSaga),
  ]);
}
